export const fr = {
  navbar: {
    home: "Accueil",
    services: "Services",
    about: "À propos",
    gallery: "Notre Travail",
    contact: "Contact",
  },
  common: {
    readMore: "Lire plus",
    submit: "Soumettre",
    learnMore: "En savoir plus",
    getQuote: "Obtenir un Devis",
    callNow: "Appelez Maintenant",
    viewAll: "Voir Tout",
  },
  home: {
    hero: {
      title: "Premier Service d'Aménagement Paysager de Montréal",
      subtitle: "Services Experts d'Entretien de Pelouse",
      serving:
        "Au service de la communauté de l'Ouest de l'Île de Montréal depuis plus d'une décennie",
      servingMobile:
        "Experts en aménagement paysager les plus fiables de l'Ouest de l'Île depuis 2012",
      getQuote: "Obtenir un devis gratuit",
      callNow: "Appelez-nous maintenant",
      viewProjects: "Voir nos projets",
    },
    services: {
      title: "Services d'aménagement paysager de premier ordre à Montréal",
      subtitle:
        "Nous offrons une variété de services professionnels d'entretien de pelouse et d'aménagement paysager dans toute la région de l'Ouest de l'Île de Montréal",
      lawn: {
        title: "Entretien de pelouse et jardin à Montréal",
        description:
          "Entretien complet de la pelouse, y compris tonte, taille de haies, élagage d'arbres et nettoyages saisonniers pour que votre propriété de Montréal soit toujours à son meilleur.",
      },
      landscape: {
        title: "Conception paysagère dans l'Ouest de l'Île",
        description:
          "Services professionnels de gazonnement, aération, fertilisation, terreautage et planification paysagère pour transformer votre espace extérieur à Montréal.",
      },
      property: {
        title: "Entretien de propriété à Montréal",
        description:
          "Solutions complètes pour les maisons de Montréal, y compris irrigation, systèmes de drainage, lavage sous pression, nettoyage de gouttières et services de transport.",
      },
      learnMore: "En savoir plus sur nos services à Montréal",
      viewAll: "Voir tous les services d'aménagement paysager de Montréal",
    },
    stats: {
      clients: "Clients satisfaits à Montréal",
      lawns: "Pelouses tondues",
      years: "Années d'expérience",
    },
    process: {
      title: "Comment obtenir votre devis",
      subtitle: "Étapes simples pour commencer avec nos services",
      step1: {
        title: "Remplissez notre formulaire",
        description:
          "Cliquez sur le bouton ci-dessous et indiquez les services dont vous avez besoin.",
      },
      step2: {
        title: "Attendez notre réponse",
        description:
          "Nous vous contacterons dès que possible après avoir reçu votre demande.",
      },
      step3: {
        title: "Détendez-vous!",
        description:
          "Une fois que nous vous envoyons un devis, il vous suffit de vous asseoir, de vous détendre et de nous laisser prendre soin de votre pelouse!",
      },
      getFreeQuote: "Obtenez votre devis gratuit maintenant",
    },
    testimonials: {
      title: "Ce que disent nos clients",
      homeowner: "Propriétaire",
      quote1:
        "Bearz a fait un excellent travail de nettoyage de ma propriété cet automne, enlevant une tonne de feuilles, nettoyant les gouttières et taillant les buissons/arbustes. Ils étaient amicaux et ponctuels, et la propriété semble magnifique!",
      quote2:
        "J'utilise Bearz depuis deux ans et ils livrent toujours! Excellente communication, fiable et font toujours un excellent travail. Je recommande fortement!",
      quote3:
        "Excellente entreprise!! Je recommande fortement, très satisfait, prix excellents! Travailleurs très respectueux, toujours gentils et prêts à aider avec tous les besoins. Ils font toujours un travail incroyable sans aucune plainte. Je continuerai certainement avec cette entreprise extraordinaire!!",
    },
    about: {
      title: "À propos de Bearz Landscaping",
      paragraph1:
        "Avec plus d'une décennie d'expérience au service de l'Ouest de l'Île, Bearz Landscaping fournit des services professionnels d'aménagement paysager aux clients résidentiels et commerciaux.",
      paragraph2:
        "Notre équipe de professionnels qualifiés est passionnée par la création de beaux espaces extérieurs qui améliorent la valeur de votre propriété et votre qualité de vie. Nous sommes fiers de notre attention aux détails et de notre engagement envers la satisfaction du client.",
      feature1: "Équipe expérimentée",
      feature2: "Service fiable",
      feature3: "Résultats de qualité",
      feature4: "Satisfaction client",
      learnMore: "En savoir plus sur nous",
    },
    cta: {
      title: "Transformez votre propriété de Montréal aujourd'hui!",
      subtitle:
        "Contactez-nous dès aujourd'hui pour une consultation gratuite et donnons vie à votre vision d'aménagement paysager à Montréal. Les experts en aménagement paysager les plus fiables de l'Ouest de l'Île.",
      getQuote: "Obtenez un devis gratuit pour Montréal",
    },
    gallery: {
      title: "Nos projets d'aménagement paysager à Montréal",
      subtitle:
        "Découvrez la qualité et le soin que nous apportons à chaque projet d'aménagement paysager à Montréal dans la région de l'Ouest de l'Île",
      hoverToSeeAfter: "Survolez pour voir l'après",
      fallCleanup: {
        title: "Nettoyage d'automne",
        description:
          "Entretien saisonnier de propriété avec élimination complète des feuilles",
      },
      lawnRejuvenation: {
        title: "Régénération de pelouse",
        description:
          "Transformation complète de pelouse avec installation de gazon frais",
      },
      lawnRestoration: {
        title: "Restauration de pelouse",
        description:
          "Transformation de pelouses inégales en espaces verts luxuriants",
      },
      equipment: {
        title: "Équipement professionnel",
        description:
          "Notre équipement de pointe garantit des résultats de qualité pour chaque travail",
      },
      project1: {
        title: "Taille professionnelle d'arbustes à Montréal",
        description:
          "Arbustes façonnés avec précision pour un look propre et élégant dans les jardins de Montréal",
      },
      project2: {
        title: "Entretien de haies à Montréal",
        description:
          "Haies parfaitement taillées avec pelouse fraîchement coupée pour les propriétés de Montréal",
      },
      project3: {
        title: "Expertise en entretien de pelouse à Montréal",
        description:
          "Motifs de tonte détaillés pour une esthétique luxueuse dans les cours de Montréal",
      },
      project4: {
        title: "Aménagement paysager riverain à Montréal",
        description:
          "Soins spécialisés pour les propriétés riveraines dans la région de Montréal",
      },
      project5: {
        title: "Service complet d'entretien de pelouse à Montréal",
        description: "Entretien complet pour une cour impeccable à Montréal",
      },
      project6: {
        title: "Entretien de pelouse à Montréal",
        description:
          "Tonte régulière pour une herbe saine et belle dans les maisons de Montréal",
      },
      requestService: "Demander un service à Montréal",
    },
  },
  footer: {
    description:
      "Nous fournissons des services d'aménagement paysager de premier ordre à l'Ouest de l'Île depuis plus d'une décennie. La qualité, la fiabilité et la satisfaction du client sont au cœur de tout ce que nous faisons.",
    quickLinks: "Liens Rapides",
    services: "Services",
    servicesList: {
      lawn: "Entretien de Pelouse",
      landscaping: "Aménagement Paysager",
      hedge: "Taille de Haies",
      pressure: "Lavage à Pression",
      allServices: "Tous les Services",
    },
    contactUs: "Contactez-Nous",
    hours: {
      weekdays: "Lundi - Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche",
      closed: "Fermé",
    },
    servicedAreas: {
      title: "Services d'aménagement paysager à Montréal dans:",
      list: "Beaconsfield, Pointe-Claire, Kirkland, Dollard-des-Ormeaux, Pierrefonds, l'Ouest de l'Île, et les régions environnantes",
    },
    copyright: "Bearz Landscaping. Tous droits réservés.",
    tagline:
      "Services d'aménagement paysager de premier ordre dans l'Ouest de l'Île de Montréal depuis 2012",
    requestQuote: "Demander un devis à Montréal",
  },

  contact: {
    title: "Contactez-nous",
    subtitle:
      "Envoyez-nous un message et nous vous répondrons dans les plus brefs délais",
    form: {
      title: "REMPLISSEZ CE FORMULAIRE POUR OBTENIR VOTRE DEVIS GRATUIT!",
      subtitle:
        "Remplissez le formulaire ci-dessous et nous vous répondrons dans les 24 heures",
      name: "Nom Complet",
      fullName: "Nom Complet",
      email: "Courriel",
      phone: "Téléphone",
      address: "Adresse",
      postalCode: "Code Postal",
      service: "Service Désiré",
      services: "Service Désiré",
      servicesNote: "Sélectionnez tout ce qui s'applique",
      message: "Demandes Spéciales ou Commentaires",
      specialRequest: "Demandes Spéciales ou Commentaires",
      marketingConsent: "J'accepte de recevoir des communications marketing",
      submit: "Soumettre la Demande de Devis",
      submitting: "Envoi en cours...",
      success: "Merci! Nous vous contacterons dans les 24 heures.",
      successTitle: "Demande de Devis Soumise avec Succès!",
      successDescription:
        "Merci pour votre intérêt! Vous recevrez un courriel de confirmation sous peu. Nous examinerons votre demande et vous contacterons dans les 24 heures. Pour les questions urgentes, veuillez nous appeler au (514) 979-8020.",
      error: "Erreur lors de l'envoi du message. Veuillez réessayer.",
      errorTitle: "Erreur de Soumission",
      selectService: "Veuillez sélectionner au moins un service.",
      required: "Requis",
      dismiss: "Fermer",
      serviceOptions: {
        lawnMowing: "Tonte de Pelouse",
        hedgeTrimming: "Taille de Haies",
        cleanups: "Nettoyages (Printemps/Automne)",
        aeration: "Aération",
        fertilization: "Fertilisation",
        topdressing: "Terreautage",
        treePruning: "Élagage d'Arbres",
        sodding: "Gazonnement",
        delivery: "Livraison en Vrac",
        exteriorPainting: "Peinture Extérieure",
        pressureWashing: "Lavage Sous Pression",
        eavestrough: "Nettoyage de Gouttières",
        transportation: "Transport",
        landscaping: "Aménagement Paysager/Pavé Uni",
        paveUni: "Pavé Uni et Re-nivellement",
        excavation: "Excavation",
        snowRemoval: "Déneigement",
      },
    },
    serviceOptions: {
      lawnMowing: "Tonte de Pelouse",
      hedgeTrimming: "Taille de Haies",
      cleanups: "Nettoyages (Printemps/Automne)",
      aeration: "Aération",
      fertilization: "Fertilisation",
      topdressing: "Terreautage",
      treePruning: "Élagage d'Arbres",
      sodding: "Gazonnement",
      delivery: "Livraison en Vrac",
      exteriorPainting: "Peinture Extérieure",
      pressureWashing: "Lavage Sous Pression",
      eavestrough: "Nettoyage de Gouttières",
      transportation: "Transport",
      landscaping: "Aménagement Paysager/Pavé Uni",
      paveUni: "Pavé Uni et Re-nivellement",
      excavation: "Excavation",
      snowRemoval: "Déneigement",
    },
    info: {
      title: "Contactez-Nous",
      subtitle:
        "Prêt à transformer votre propriété? Contactez-nous dès aujourd'hui!",
      phone: "514-979-8020",
      email: "mattellerton.landscaping@gmail.com",
      hours: "Lun-Ven: 9h-17h",
      areas: "Servant l'Ouest de l'Île de Montréal",
    },
    contactInfo: {
      phone: "Téléphone",
      phoneNumber: "514-979-8020",
      email: "Courriel",
      emailAddress: "mattellerton.landscaping@gmail.com",
      location: "Emplacement",
      address: "Montréal, Québec",
    },
    confirmationEmail: {
      fromFacebookAd: "Provient d'une publicité Facebook",
    },
  },
  // Navigation
  nav: {
    home: "Accueil",
    about: "À Propos",
    services: "Services",
    contact: "Contact",
    getQuote: "Obtenir un Devis",
    callNow: "Appelez-nous",
  },

  // Hero Section
  hero: {
    title: "Services Professionnels d'Aménagement Paysager à Montréal",
    subtitle:
      "Transformez votre espace extérieur avec des services experts d'aménagement paysager, d'entretien de pelouse et de maintenance de propriété",
    cta: "Devis Gratuit",
    phone: "514-979-8020",
    trustedBy: "Approuvé par plus de 500 propriétaires de Montréal",
  },

  // Services
  services: {
    header: {
      title: "Nos Services Professionnels",
      subtitle:
        "Solutions complètes d'aménagement paysager adaptées à vos besoins",
    },
    cta: {
      title: "Prêt à Transformer Votre Propriété?",
      subtitle:
        "Obtenez une consultation gratuite et un devis pour votre projet d'aménagement paysager aujourd'hui",
      getQuote: "Devis Gratuit",
    },
    callNow: "Appelez Maintenant",
    callPhone: "Appelez: 514-979-8020",

    residential: {
      title: "Services Résidentiels",
      subtitle:
        "Services professionnels d'aménagement paysager pour propriétaires",
      services: {
        lawnCare: {
          title: "Entretien de Pelouse",
          description:
            "Gardez votre pelouse saine et belle avec nos services professionnels d'entretien incluant la tonte, la fertilisation et les traitements saisonniers.",
        },
        hedgeTree: {
          title: "Services d'Arbres et Haies",
          description:
            "Élagage, taille et soins experts pour vos arbres et haies afin de maintenir la santé et améliorer l'apparence de votre propriété.",
        },
        seasonal: {
          title: "Nettoyage Saisonnier",
          description:
            "Services complets de nettoyage printanier et automnal pour préparer votre aménagement paysager à chaque saison.",
        },
        treatments: {
          title: "Traitements de Pelouse",
          description:
            "Fertilisation professionnelle et gestion des ravageurs pour maintenir votre pelouse en parfait état.",
        },
      },
      features: {
        professional: "Équipement et techniques professionnels",
        customized: "Plans de service personnalisés",
        regular: "Programmes d'entretien réguliers disponibles",
      },
      getQuoteForService: "Obtenir un Devis pour ce Service",
      banner: {
        title: "Prêt à Transformer l'Aménagement de Votre Maison?",
        subtitle:
          "Nos experts en aménagement paysager résidentiel sont prêts à donner vie à votre vision. Obtenez un devis personnalisé aujourd'hui!",
        cta: "Obtenez Votre Devis Résidentiel Gratuit",
      },
    },

    commercial: {
      title: "Services Commerciaux",
      subtitle:
        "Solutions professionnelles d'aménagement paysager pour entreprises et propriétés commerciales",
      services: {
        sodding: {
          title: "Pose de Gazon et Aménagement",
          description:
            "Services professionnels de pose de gazon et solutions d'aménagement paysager incluant l'installation d'imbriqués pour transformer instantanément votre espace extérieur.",
        },
        delivery: {
          title: "Services de Livraison",
          description:
            "Livraison de matériaux en vrac et services de transport pour tous vos besoins d'aménagement paysager.",
        },
        property: {
          title: "Entretien de Propriété",
          description:
            "Solutions complètes de propriété incluant le lavage sous pression, la peinture extérieure et le nettoyage de gouttières.",
        },
      },
      requestQuote: "Demander un Devis",
      callForDetails: "Appelez pour Détails",
      banner: {
        title: "Besoin de Solutions d'Aménagement Paysager Commercial?",
        subtitle:
          "Services professionnels d'entretien et d'aménagement paysager pour améliorer votre propriété d'entreprise et créer une impression durable.",
        cta: "Obtenir un Devis Commercial",
      },
    },

    specialty: {
      title: "Services Spécialisés",
      subtitle:
        "Services supplémentaires pour améliorer et maintenir votre espace extérieur",
      services: {
        painting: {
          title: "Peinture Extérieure",
          description:
            "Services de peinture extérieure de haute qualité pour améliorer et protéger l'apparence de votre maison tout en augmentant sa valeur.",
        },
        pressure: {
          title: "Lavage Sous Pression",
          description:
            "Services professionnels de lavage sous pression pour nettoyer les entrées, terrasses, patios et revêtements, éliminant la saleté, la crasse, la moisissure et le mildiou.",
        },
        gutter: {
          title: "Nettoyage de Gouttières",
          description:
            "Nettoyage et entretien réguliers des gouttières pour prévenir les dégâts d'eau, les fuites et les problèmes de fondation.",
        },
        transportation: {
          title: "Services de Transport",
          description:
            "Services de transport fiables pour matériaux d'aménagement paysager, équipement et enlèvement de débris pour soutenir votre projet.",
        },
      },
      banner: {
        title: "Besoin de Services Supplémentaires pour Votre Propriété?",
        subtitle:
          "Du lavage sous pression au nettoyage de gouttières, nous offrons des services complets d'entretien de propriété pour garder votre maison ou entreprise à son meilleur.",
        cta: "Demander des Services Spécialisés",
      },
    },

    detailed: {
      title: "Pages de Services Détaillés",
      subtitle:
        "Apprenez-en plus sur nos services complets d'aménagement paysager",
      services: {
        treePruning: {
          title: "Élagage d'Arbres",
          description:
            "Services professionnels d'élagage et de soins d'arbres pour des arbres sains et beaux.",
        },
        gardening: {
          title: "Conception et Entretien de Jardin",
          description:
            "Services de conception de jardin personnalisé et d'entretien continu.",
        },
        grassCutting: {
          title: "Tonte de Gazon",
          description:
            "Services professionnels de tonte de gazon et d'entretien de pelouse.",
        },
        springFallCleanup: {
          title: "Nettoyage Saisonnier",
          description:
            "Services de nettoyage printanier et automnal pour l'entretien de propriété toute l'année.",
        },
        parkingLotCleaning: {
          title: "Nettoyage de Stationnement",
          description:
            "Services commerciaux de nettoyage et d'entretien de stationnement.",
        },
        hedgeTrimming: {
          title: "Taille de Haies",
          description:
            "Services de taille et de façonnage de haies de précision.",
        },
        sodInstallation: {
          title: "Installation de Gazon",
          description:
            "Installation professionnelle de gazon pour une transformation instantanée de pelouse.",
        },
        relevelling: {
          title: "Nivellement de Pelouse",
          description:
            "Services professionnels de nivellement de pelouse pour des surfaces lisses et uniformes.",
        },
        paveWalkways: {
          title: "Pavé et Allées",
          description:
            "Belles solutions d'aménagement paysager dur avec pavés et allées.",
        },
        paveUniReleveling: {
          title: "Pavé Uni et Nivellement",
          description:
            "Installation experte de pavé uni et nivellement de surfaces pour entrées et allées.",
        },
        excavation: {
          title: "Excavation",
          description:
            "Services professionnels d'excavation et de préparation de terrain pour projets résidentiels et commerciaux.",
        },
        snowRemoval: {
          title: "Déneigement",
          description:
            "Déneigement fiable des entrées et pelletage des allées pour garder votre propriété sécuritaire tout l'hiver.",
        },
      },
      getQuote: "Obtenir un Devis",
      learnMore: "En Savoir Plus",
      notFound: {
        title: "Vous ne Trouvez pas ce que Vous Cherchez?",
        subtitle:
          "Nous offrons de nombreux services spécialisés au-delà de ce qui est listé. Contactez-nous pour discuter de vos besoins spécifiques.",
        discuss: "Discutez de Votre Projet",
      },
    },
  },

  // Grass Cutting Service Page
  grassCutting: {
    title: "Services Professionnels de Tonte de Gazon",
    subtitle:
      "Gardez votre pelouse impeccable avec nos services fiables et professionnels de tonte de gazon et d'entretien de pelouse.",
    overviewTitle: "Tonte de Gazon Experte et Entretien de Pelouse",
    overviewDescription:
      "Nos techniciens expérimentés fournissent des services de tonte de gazon constants et fiables qui maintiennent votre pelouse saine, belle et bien entretenue toute la saison de croissance. Nous utilisons un équipement professionnel et des techniques appropriées pour assurer les meilleurs résultats.",

    features: {
      regular: {
        title: "Horaires de Tonte Réguliers",
        description:
          "Horaires de tonte constants pour maintenir une santé et une apparence optimales du gazon.",
      },
      equipment: {
        title: "Équipement Professionnel",
        description:
          "Équipement de haute qualité et bien entretenu pour une tonte précise et efficace.",
      },
      techniques: {
        title: "Techniques de Tonte Appropriées",
        description:
          "Hauteur de coupe correcte et techniques pour promouvoir une croissance saine du gazon.",
      },
      cleanup: {
        title: "Nettoyage Complet",
        description:
          "Nettoyage minutieux de toutes les coupures de gazon et débris après chaque service.",
      },
      weather: {
        title: "Planification Dépendante de la Météo",
        description:
          "Planification flexible basée sur les conditions météorologiques pour des résultats optimaux.",
      },
      mulching: {
        title: "Options de Paillis",
        description:
          "Options de paillis naturel pour retourner les nutriments à votre pelouse.",
      },
      edging: {
        title: "Bordure de Précision",
        description:
          "Bordure propre et précise autour des allées, entrées et plates-bandes pour un look soigné.",
      },
      flexible: {
        title: "Horaires Flexibles",
        description:
          "Horaires de tonte personnalisables pour s'adapter à votre style de vie et aux besoins de votre pelouse.",
      },
      seasonal: {
        title: "Ajustements Saisonniers",
        description:
          "Ajustements de hauteur et fréquence de tonte basés sur les modèles de croissance saisonniers.",
      },
    },

    benefits: [
      "Amélioration de la santé et de l'apparence de la pelouse",
      "Résultats constants et professionnels",
      "Économie de temps pour les propriétaires",
      "Amélioration de l'attrait extérieur de la propriété",
      "Promotion de la croissance optimale du gazon",
    ],

    processTitle: "Notre Processus de Tonte de Gazon",
    processDescription:
      "Services professionnels de tonte de gazon pour un entretien impeccable de pelouse",
    process: {
      step1: {
        title: "Évaluation de la Pelouse",
        description:
          "Nous évaluons l'état de votre pelouse et les exigences de tonte.",
      },
      step2: {
        title: "Horaire Personnalisé",
        description:
          "Nous créons un horaire de tonte adapté aux besoins de votre pelouse.",
      },
      step3: {
        title: "Tonte Professionnelle",
        description:
          "Notre équipe effectue une tonte précise utilisant un équipement professionnel.",
      },
      step4: {
        title: "Nettoyage Complet",
        description:
          "Nous nettoyons tous les débris et laissons votre propriété propre et ordonnée.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour un Entretien de Pelouse Professionnel?",
      subtitle:
        "Nos experts en tonte de gazon sont prêts à garder votre pelouse à son meilleur.",
      getQuote: "Obtenir un Devis Gratuit de Tonte de Gazon",
      callNow: "Appelez pour une Consultation d'Entretien de Pelouse",
    },

    cta: {
      title: "Obtenez Votre Pelouse Parfaite Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services professionnels de tonte de gazon qui maintiendront votre pelouse en parfait état toute l'année.",
      getQuote: "Commencez Votre Service d'Entretien de Pelouse",
    },
  },

  // Spring/Fall Cleanup Service Page
  springFallCleanup: {
    title: "Services Professionnels de Nettoyage Printanier et Automnal",
    subtitle:
      "Préparez votre propriété pour les saisons changeantes avec nos services complets de nettoyage printanier et automnal.",
    overviewTitle: "Nettoyage Expert de Propriété Saisonnier",
    overviewDescription:
      "Nos services complets de nettoyage printanier et automnal préparent votre propriété pour les saisons changeantes. Du ramassage de feuilles au nettoyage de débris, nous nous assurons que votre aménagement paysager est prêt pour ce qui s'en vient.",

    features: {
      spring: {
        title: "Nettoyage Printanier",
        description:
          "Préparation printanière complète incluant l'enlèvement de débris et l'entretien des plates-bandes.",
      },
      fall: {
        title: "Nettoyage Automnal",
        description:
          "Nettoyage automnal minutieux incluant le ramassage de feuilles et les services d'hivernage.",
      },
      debris: {
        title: "Enlèvement de Débris",
        description:
          "Enlèvement complet de tous les débris de cour, branches et déchets saisonniers.",
      },
      pruning: {
        title: "Élagage et Taille",
        description:
          "Élagage et taille saisonniers pour favoriser une croissance saine des plantes.",
      },
      mulching: {
        title: "Services de Paillis",
        description:
          "Application de paillis frais pour protéger les plantes et améliorer l'apparence.",
      },
      winterization: {
        title: "Hivernage",
        description:
          "Préparation complète de la propriété pour la protection contre les intempéries hivernales.",
      },
    },

    benefits: [
      "Préparation complète de propriété saisonnière",
      "Amélioration de l'attrait extérieur toute l'année",
      "Protection pour les plantes et l'aménagement paysager",
      "Économie de temps pour les propriétaires",
      "Équipement professionnel et expertise",
      "Enlèvement complet de débris",
    ],

    processTitle: "Notre Processus de Nettoyage Saisonnier",
    processDescription:
      "Services professionnels de nettoyage printanier et automnal pour l'entretien de propriété toute l'année",
    process: {
      step1: {
        title: "Évaluation de la Propriété",
        description:
          "Nous évaluons les besoins et exigences de nettoyage saisonnier de votre propriété.",
      },
      step2: {
        title: "Plan Personnalisé",
        description:
          "Nous créons un plan de nettoyage adapté à votre propriété et la saison.",
      },
      step3: {
        title: "Nettoyage Professionnel",
        description:
          "Notre équipe effectue un nettoyage complet utilisant un équipement professionnel.",
      },
      step4: {
        title: "Enlèvement Complet",
        description:
          "Nous enlevons tous les débris et laissons votre propriété propre et préparée.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour des Soins de Propriété Saisonniers?",
      subtitle:
        "Nos experts en nettoyage sont prêts à préparer votre propriété pour les saisons changeantes.",
      getQuote: "Obtenir un Devis Gratuit de Nettoyage",
      callNow: "Appelez pour une Consultation de Nettoyage",
    },

    cta: {
      title: "Préparez Votre Propriété pour la Saison Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services professionnels de nettoyage printanier et automnal qui garderont votre propriété à son meilleur toute l'année.",
      getQuote: "Commencez Votre Service de Nettoyage Saisonnier",
    },
  },

  // Hedge Trimming Service Page
  hedgeTrimming: {
    title: "Services Professionnels de Taille de Haies",
    subtitle:
      "Gardez vos haies nettes, saines et magnifiquement façonnées avec nos services experts de taille et d'entretien de haies.",
    overviewTitle: "Taille et Façonnage Expert de Haies",
    overviewDescription:
      "Nos techniciens qualifiés fournissent des services précis de taille de haies qui maintiennent la santé et l'apparence de vos haies. Nous utilisons un équipement professionnel et des techniques appropriées pour assurer des coupes nettes et promouvoir une croissance saine.",

    features: {
      precision: {
        title: "Coupe de Précision",
        description:
          "Techniques de coupe précises qui favorisent une croissance saine et une belle forme.",
      },
      shaping: {
        title: "Façonnage Personnalisé",
        description:
          "Services de façonnage expert pour créer et maintenir les formes de haies désirées.",
      },
      timing: {
        title: "Timing Optimal",
        description:
          "Timing des coupes pour la meilleure santé et croissance de vos haies.",
      },
      cleanup: {
        title: "Nettoyage Complet",
        description:
          "Nettoyage minutieux de toutes les tailles et débris après chaque service.",
      },
      maintenance: {
        title: "Entretien Régulier",
        description:
          "Horaires d'entretien continus pour garder les haies en parfait état.",
      },
      restoration: {
        title: "Services de Restauration",
        description:
          "Réhabilitation de haies envahies ou négligées pour retrouver la santé.",
      },
    },

    benefits: [
      "Amélioration de l'attrait extérieur de la propriété",
      "Amélioration de la santé et de la croissance des haies",
      "Apparence professionnelle et nette",
      "Augmentation de la valeur de la propriété",
      "Économie de temps pour les propriétaires",
      "Façonnage et entretien expert",
    ],

    processTitle: "Notre Processus de Taille de Haies",
    processDescription:
      "Services professionnels de taille de haies pour des haies belles et saines",
    process: {
      step1: {
        title: "Évaluation des Haies",
        description:
          "Nous évaluons l'état de vos haies et les exigences de taille.",
      },
      step2: {
        title: "Plan Personnalisé",
        description:
          "Nous créons un plan de taille adapté à vos types de haies et objectifs.",
      },
      step3: {
        title: "Taille Professionnelle",
        description:
          "Notre équipe effectue une taille précise utilisant un équipement professionnel.",
      },
      step4: {
        title: "Nettoyage Complet",
        description:
          "Nous nettoyons tous les débris et laissons votre propriété propre et ordonnée.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour des Soins de Haies Professionnels?",
      subtitle:
        "Nos experts en taille de haies sont prêts à garder vos haies à leur meilleur.",
      getQuote: "Obtenir un Devis Gratuit de Taille de Haies",
      callNow: "Appelez pour une Consultation de Soins de Haies",
    },

    cta: {
      title: "Obtenez de Belles Haies Saines Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services professionnels de taille de haies qui garderont vos haies en parfait état toute l'année.",
      getQuote: "Commencez Votre Service de Soins de Haies",
    },
  },

  // Tree Pruning Service Page
  treePruning: {
    title: "Services Professionnels d'Élagage d'Arbres",
    subtitle:
      "Gardez vos arbres sains, sécuritaires et beaux avec nos services experts d'élagage et de soins d'arbres.",
    overviewTitle: "Soins et Élagage Expert d'Arbres",
    overviewDescription:
      "Nos arboriculteurs certifiés fournissent des services professionnels d'élagage d'arbres qui favorisent la santé des arbres, améliorent la sécurité et rehaussent la beauté de votre aménagement paysager. Nous utilisons des techniques et équipements appropriés pour assurer la santé à long terme de vos arbres.",

    features: {
      assessment: {
        title: "Évaluation de la Santé des Arbres",
        description:
          "Évaluation complète de la santé et de l'intégrité structurelle des arbres.",
      },
      safety: {
        title: "Approche Sécurité d'Abord",
        description:
          "Mesures de sécurité professionnelles et services assurés pour la tranquillité d'esprit.",
      },
      techniques: {
        title: "Techniques d'Élagage Appropriées",
        description:
          "Méthodes d'élagage expertes qui favorisent une croissance saine et la longévité des arbres.",
      },
      cleanup: {
        title: "Nettoyage Complet",
        description:
          "Nettoyage minutieux et enlèvement de tous les débris après l'élagage.",
      },
      insurance: {
        title: "Entièrement Assuré",
        description:
          "Couverture d'assurance complète pour la protection de la propriété et la tranquillité d'esprit.",
      },
      consultation: {
        title: "Consultation d'Expert",
        description:
          "Conseils professionnels sur les soins d'arbres et recommandations d'entretien.",
      },
    },

    benefits: [
      "Amélioration de la santé et longévité des arbres",
      "Sécurité renforcée de la propriété",
      "Augmentation de la valeur de la propriété",
      "Meilleure esthétique du paysage",
      "Prévention des maladies d'arbres",
      "Soins d'expert professionnel",
    ],

    processTitle: "Notre Processus d'Élagage d'Arbres",
    processDescription:
      "Services professionnels d'élagage d'arbres pour des arbres sains et beaux",

    timing: {
      title: "Quand Élaguer Vos Arbres",
      spring: {
        title: "Élagage Printanier",
        description:
          "Moment idéal pour la plupart des arbres à feuilles caduques, favorisant une croissance saine.",
      },
      emergency: {
        title: "Élagage d'Urgence",
        description:
          "Attention immédiate pour les branches endommagées ou dangereuses.",
      },
      specific: {
        title: "Timing Spécifique aux Espèces",
        description:
          "Timing personnalisé basé sur vos espèces d'arbres spécifiques et besoins.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour des Soins d'Arbres Professionnels?",
      subtitle:
        "Nos arboriculteurs certifiés sont prêts à garder vos arbres sains et beaux.",
      getQuote: "Obtenir un Devis Gratuit d'Élagage d'Arbres",
      callNow: "Appelez pour une Consultation de Soins d'Arbres",
    },

    cta: {
      title: "Obtenez des Arbres Sains et Beaux Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services professionnels d'élagage d'arbres qui garderont vos arbres en parfait état toute l'année.",
      getQuote: "Commencez Votre Service de Soins d'Arbres",
    },
  },

  // Relevelling Service Page
  relevelling: {
    title: "Services Professionnels de Nivellement de Pelouse",
    subtitle:
      "Transformez les pelouses inégales en surfaces lisses et parfaites avec nos services experts de nivellement et de nivellement de pelouse.",
    overviewTitle: "Nivellement et Nivellement Expert de Pelouse",
    overviewDescription:
      "Nos services professionnels de nivellement de pelouse s'attaquent aux surfaces inégales, aux points bas et aux problèmes de drainage pour créer des pelouses lisses et nivelées qui sont plus faciles à entretenir et plus agréables à utiliser.",

    features: {
      assessment: {
        title: "Évaluation de la Pelouse",
        description:
          "Évaluation complète de la surface de la pelouse et des exigences de drainage.",
      },
      grading: {
        title: "Nivellement Professionnel",
        description:
          "Techniques de nivellement expertes pour obtenir une pente et un drainage appropriés.",
      },
      soil: {
        title: "Préparation du Sol",
        description:
          "Préparation et amendement de sol de qualité pour une croissance optimale de la pelouse.",
      },
      compaction: {
        title: "Compactage Approprié",
        description:
          "Compactage de sol approprié pour prévenir les problèmes de tassement futurs.",
      },
      seeding: {
        title: "Ensemencement et Pose de Gazon",
        description:
          "Ensemencement ou pose de gazon professionnel pour établir une nouvelle croissance de pelouse.",
      },
      drainage: {
        title: "Solutions de Drainage",
        description:
          "Solutions de drainage appropriées pour prévenir l'accumulation d'eau et les problèmes.",
      },
    },

    benefits: [
      "Surface de pelouse lisse et uniforme",
      "Amélioration du drainage et du flux d'eau",
      "Entretien de pelouse plus facile et tonte",
      "Amélioration de l'apparence de la propriété",
      "Augmentation de la valeur de la propriété",
      "Service expert professionnel",
    ],

    processTitle: "Notre Processus de Nivellement de Pelouse",
    processDescription:
      "Services professionnels de nivellement de pelouse pour des pelouses lisses et belles",
    process: {
      step1: {
        title: "Évaluation du Site",
        description:
          "Nous évaluons l'état de votre pelouse et les exigences de nivellement.",
      },
      step2: {
        title: "Plan de Nivellement",
        description:
          "Nous créons un plan de nivellement détaillé pour des résultats optimaux.",
      },
      step3: {
        title: "Nivellement Professionnel",
        description:
          "Notre équipe effectue un nivellement précis utilisant un équipement professionnel.",
      },
      step4: {
        title: "Restauration de la Pelouse",
        description:
          "Nous complétons le processus avec l'ensemencement ou la pose de gazon pour une nouvelle croissance.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour une Pelouse Nivelée?",
      subtitle:
        "Nos experts en nivellement sont prêts à transformer votre pelouse inégale en une surface lisse et belle.",
      getQuote: "Obtenir un Devis Gratuit de Nivellement",
      callNow: "Appelez pour une Évaluation de Pelouse",
    },

    cta: {
      title: "Obtenez Votre Pelouse Parfaitement Nivelée Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services professionnels de nivellement de pelouse qui transformeront votre propriété.",
      getQuote: "Commencez Votre Projet de Nivellement de Pelouse",
    },
  },

  // Parking Lot Cleaning Service Page
  parkingLotCleaning: {
    title: "Services Professionnels de Nettoyage de Stationnement",
    subtitle:
      "Gardez vos aires de stationnement commerciales propres, sécuritaires et professionnelles avec nos services complets de nettoyage de stationnement.",
    overviewTitle: "Entretien Expert de Stationnement Commercial",
    overviewDescription:
      "Nos services professionnels de nettoyage de stationnement assurent que votre propriété commerciale maintient une apparence propre, sécuritaire et professionnelle qui fait une impression positive sur les clients et visiteurs.",

    features: {
      sweeping: {
        title: "Balayage Motorisé",
        description:
          "Balayage motorisé professionnel pour enlever les débris, feuilles et détritus.",
      },
      pressure: {
        title: "Lavage Sous Pression",
        description:
          "Lavage haute pression pour enlever les taches, crasse et accumulation.",
      },
      debris: {
        title: "Enlèvement de Débris",
        description:
          "Enlèvement complet de tous les débris de stationnement, déchets et matériaux indésirables.",
      },
      maintenance: {
        title: "Entretien Régulier",
        description:
          "Programmes d'entretien planifiés pour garder les propriétés constamment propres.",
      },
      seasonal: {
        title: "Services Saisonniers",
        description:
          "Nettoyage saisonnier spécialisé incluant l'enlèvement de feuilles et la préparation hivernale.",
      },
      commercial: {
        title: "Solutions Commerciales",
        description:
          "Solutions complètes d'entretien de propriété commerciale.",
      },
    },

    benefits: [
      "Apparence professionnelle d'entreprise",
      "Amélioration de l'expérience client",
      "Amélioration de la sécurité et de l'accessibilité",
      "Conformité aux réglementations",
      "Prolongation de la vie du pavé",
      "Entretien rentable",
    ],

    processTitle: "Notre Processus de Nettoyage de Stationnement",
    processDescription:
      "Services professionnels de nettoyage de stationnement pour propriétés commerciales",
    process: {
      step1: {
        title: "Évaluation de la Propriété",
        description:
          "Nous évaluons les besoins de nettoyage et d'entretien de votre stationnement.",
      },
      step2: {
        title: "Horaire de Service",
        description:
          "Nous créons un horaire d'entretien adapté aux besoins de votre entreprise.",
      },
      step3: {
        title: "Nettoyage Professionnel",
        description:
          "Notre équipe effectue un nettoyage minutieux utilisant un équipement commercial.",
      },
      step4: {
        title: "Assurance Qualité",
        description:
          "Nous nous assurons que toutes les zones répondent à nos hauts standards de propreté.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour des Soins de Propriété Professionnels?",
      subtitle:
        "Nos experts en nettoyage commercial sont prêts à garder votre stationnement à son meilleur.",
      getQuote: "Obtenir un Devis Commercial Gratuit",
      callNow: "Appelez pour une Évaluation de Propriété",
    },

    cta: {
      title: "Obtenez des Soins de Stationnement Professionnels Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services complets de nettoyage de stationnement qui garderont votre propriété commerciale professionnelle.",
      getQuote: "Commencez Votre Service Commercial",
    },
  },

  // Gardening Service Page
  gardening: {
    title: "Services Professionnels de Conception et Entretien de Jardins",
    subtitle:
      "Créez et entretenez de beaux jardins avec nos services experts de conception de jardins, plantation et entretien continu.",
    overviewTitle: "Conception et Soins Experts de Jardins",
    overviewDescription:
      "Nos services professionnels de jardinage combinent la conception créative avec une connaissance experte des plantes pour créer et maintenir de beaux jardins florissants qui améliorent la beauté et la valeur de votre propriété.",

    features: {
      design: {
        title: "Conception de Jardin",
        description:
          "Conception de jardin personnalisée adaptée à votre espace et vos préférences.",
      },
      planting: {
        title: "Plantation Professionnelle",
        description:
          "Sélection et installation experte de plantes pour une croissance optimale.",
      },
      maintenance: {
        title: "Entretien de Jardin",
        description: "Entretien continu pour garder votre jardin sain et beau.",
      },
      seasonal: {
        title: "Soins Saisonniers",
        description:
          "Soins de jardin saisonniers incluant l'élagage, la fertilisation et le nettoyage.",
      },
      consultation: {
        title: "Consultation Experte",
        description:
          "Conseils professionnels sur la sélection de plantes et les soins de jardin.",
      },
      soil: {
        title: "Santé du Sol",
        description:
          "Test et amendement du sol pour une santé et croissance optimales des plantes.",
      },
    },

    benefits: [
      "Conceptions de jardins beaux et personnalisés",
      "Sélection et soins experts des plantes",
      "Valeur de propriété augmentée",
      "Beauté de jardin toute l'année",
      "Service d'entretien professionnel",
      "Pratiques de jardinage durables",
    ],

    processTitle: "Notre Processus de Conception de Jardin",
    processDescription:
      "Services professionnels de conception et entretien de jardins pour de beaux espaces extérieurs",
    process: {
      step1: {
        title: "Consultation de Conception",
        description:
          "Nous discutons de votre vision et évaluons votre espace de jardin et vos besoins.",
      },
      step2: {
        title: "Conception Personnalisée",
        description:
          "Nous créons un plan de conception de jardin personnalisé adapté à votre espace.",
      },
      step3: {
        title: "Installation Professionnelle",
        description:
          "Notre équipe installe les plantes et caractéristiques selon la conception.",
      },
      step4: {
        title: "Soins Continus",
        description:
          "Nous fournissons un entretien continu pour garder votre jardin florissant.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour Votre Jardin de Rêve?",
      subtitle:
        "Nos experts en conception de jardins sont prêts à créer l'espace extérieur parfait pour vous.",
      getQuote: "Obtenir un Devis Gratuit de Conception de Jardin",
      callNow: "Appelez pour une Consultation de Conception",
    },

    cta: {
      title: "Obtenez Votre Beau Jardin Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services professionnels de conception et entretien de jardins qui transformeront votre espace extérieur.",
      getQuote: "Commencez Votre Projet de Jardin",
    },
  },

  // Pavé & Walkways Service Page
  paveWalkways: {
    title: "Installation Professionnelle de Pavé et Allées",
    subtitle:
      "Transformez vos espaces extérieurs avec de belles installations durables de pavé et allées qui rehaussent l'attrait de votre propriété.",
    overviewTitle: "Solutions d'Aménagement Paysager Dur Expert",
    overviewDescription:
      "Nos services professionnels d'installation de pavé et allées créent des espaces extérieurs magnifiques et fonctionnels utilisant des matériaux de haute qualité et un savoir-faire expert pour une beauté et durabilité durables.",

    features: {
      design: {
        title: "Conception Personnalisée",
        description:
          "Conceptions d'aménagement paysager dur personnalisées adaptées à votre propriété et style.",
      },
      materials: {
        title: "Matériaux de Qualité",
        description:
          "Pierres de pavé et matériaux premium pour la durabilité et la beauté.",
      },
      installation: {
        title: "Installation Experte",
        description:
          "Techniques d'installation professionnelles pour des résultats durables.",
      },
      drainage: {
        title: "Drainage Approprié",
        description:
          "Solutions de drainage conçues pour prévenir les problèmes d'eau.",
      },
      maintenance: {
        title: "Service d'Entretien",
        description:
          "Entretien continu pour garder votre aménagement paysager dur à son meilleur.",
      },
      warranty: {
        title: "Garantie de Qualité",
        description: "Garantie complète sur les matériaux et la main-d'œuvre.",
      },
    },

    benefits: [
      "Amélioration de l'attrait extérieur de la propriété",
      "Augmentation de la valeur de la propriété",
      "Surfaces durables et durables",
      "Exigences d'entretien faibles",
      "Options de conception personnalisées",
      "Installation experte professionnelle",
    ],

    processTitle: "Notre Processus d'Installation",
    processDescription:
      "Installation professionnelle de pavé et allées pour de beaux espaces extérieurs",
    process: {
      step1: {
        title: "Consultation de Conception",
        description:
          "Nous discutons de votre vision et évaluons votre espace pour la conception parfaite.",
      },
      step2: {
        title: "Sélection de Matériaux",
        description:
          "Nous vous aidons à choisir les meilleurs matériaux pour votre projet et budget.",
      },
      step3: {
        title: "Installation Professionnelle",
        description:
          "Notre équipe installe votre pavé et allées avec une précision experte.",
      },
      step4: {
        title: "Inspection Finale",
        description:
          "Nous effectuons une inspection minutieuse pour assurer des résultats parfaits.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour un Bel Aménagement Paysager Dur?",
      subtitle:
        "Nos experts en aménagement paysager dur sont prêts à transformer votre espace extérieur avec de magnifiques pavés et allées.",
      getQuote: "Obtenir un Devis Gratuit d'Aménagement Paysager Dur",
      callNow: "Appelez pour une Consultation de Conception",
    },

    cta: {
      title: "Obtenez Votre Aménagement Paysager Dur de Rêve Aujourd'hui",
      subtitle:
        "Contactez-nous pour une installation professionnelle de pavé et allées qui rehaussera la beauté et la valeur de votre propriété.",
      getQuote: "Commencez Votre Projet d'Aménagement Paysager Dur",
    },
  },

  // Pavé Uni & Releveling Service Page
  paveUniReleveling: {
    title: "Services de Pavé Uni et Nivellement",
    subtitle:
      "Installation professionnelle de pavé uni et nivellement de surfaces pour entrées, allées et patios à travers l'Ouest de l'Île.",
    overviewTitle: "Pavé Uni Expert et Nivellement de Surfaces",
    overviewDescription:
      "Nous nous spécialisons dans l'installation de magnifiques pavés uni pour entrées, allées et patios, ainsi que le nivellement de surfaces inégales qui ont bougé ou se sont tassées avec le temps. Notre équipe offre des résultats durables avec des matériaux de qualité.",

    features: {
      installation: {
        title: "Installation de Pavé Uni",
        description:
          "Installation professionnelle de pavés interverrouillés pour entrées, allées, patios et pourtours de piscine.",
      },
      releveling: {
        title: "Nivellement de Surfaces",
        description:
          "Remise à niveau experte des surfaces de pavé affaissées ou inégales pour un résultat sécuritaire et uniforme.",
      },
      design: {
        title: "Motifs et Couleurs Personnalisés",
        description:
          "Large sélection de styles, motifs et couleurs de pavés pour compléter l'extérieur de votre maison.",
      },
      base: {
        title: "Préparation de Base Adéquate",
        description:
          "Excavation complète et installation d'une base de gravier compactée pour prévenir les affaissements futurs.",
      },
      drainage: {
        title: "Solutions de Drainage",
        description:
          "Pente et drainage conçus pour diriger l'eau et protéger votre investissement en pavé.",
      },
      edging: {
        title: "Retenues de Bordure et Finition",
        description:
          "Retenues de bordure durables et sable de jointoiement de précision pour un résultat soigné et durable.",
      },
    },

    benefits: [
      "Augmentation de l'attrait extérieur et de la valeur de la propriété",
      "Surfaces durables qui résistent aux hivers montréalais",
      "Peu d'entretien — ne craque pas comme le béton coulé",
      "Les pavés individuels peuvent être remplacés si endommagés",
      "Designs personnalisés adaptés à votre maison",
      "Surfaces sécuritaires et planes qui préviennent les chutes",
    ],

    processTitle: "Notre Processus de Pavé Uni et Nivellement",
    processDescription:
      "De la consultation à l'inspection finale, nous gérons chaque détail",
    process: {
      step1: {
        title: "Consultation sur Place",
        description:
          "Nous évaluons votre espace, discutons des options de design et fournissons une estimation détaillée.",
      },
      step2: {
        title: "Excavation et Préparation de Base",
        description:
          "Nous excavons à la profondeur requise et installons une base de gravier compactée pour la stabilité.",
      },
      step3: {
        title: "Installation des Pavés",
        description:
          "Notre équipe installe les pavés selon le motif choisi avec des coupes précises et des joints uniformes.",
      },
      step4: {
        title: "Finition et Nettoyage",
        description:
          "Nous appliquons le sable de jointoiement, compactons la surface et laissons votre propriété impeccable.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour une Belle Nouvelle Entrée ou Allée?",
      subtitle:
        "Nos experts en pavé uni sont prêts à transformer vos surfaces extérieures avec une qualité durable.",
      getQuote: "Obtenir un Devis Gratuit de Pavé Uni",
      callNow: "Appelez pour une Consultation",
    },

    cta: {
      title: "Transformez Vos Surfaces Extérieures Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services professionnels d'installation de pavé uni et de nivellement à travers l'Ouest de l'Île de Montréal.",
      getQuote: "Démarrer Votre Projet de Pavé Uni",
    },
  },

  // Excavation Service Page
  excavation: {
    title: "Services Professionnels d'Excavation",
    subtitle:
      "Excavation fiable et préparation de terrain pour projets résidentiels et commerciaux à travers l'Ouest de l'Île de Montréal.",
    overviewTitle: "Excavation Expert et Préparation de Terrain",
    overviewDescription:
      "Notre équipe expérimentée offre des services d'excavation professionnels pour une grande variété de projets — de la préparation d'entrées et de patios aux travaux de drainage, fouilles de fondation et défrichement. Nous utilisons un équipement moderne pour réaliser les travaux efficacement et en toute sécurité.",

    features: {
      sitePreparing: {
        title: "Préparation de Terrain",
        description:
          "Déblaiement et préparation complets du terrain avant le début des projets de construction, d'aménagement ou de pavage.",
      },
      grading: {
        title: "Nivellement et Planage",
        description:
          "Nivellement précis pour établir les pentes appropriées et des surfaces planes pour le drainage et la stabilité.",
      },
      trenchDig: {
        title: "Tranchées",
        description:
          "Tranchées précises pour tuyaux de drainage, conduites de services publics, systèmes d'irrigation et drains français.",
      },
      landClearing: {
        title: "Défrichement",
        description:
          "Enlèvement de souches, roches, vieux matériaux et débris pour préparer le terrain à de nouveaux projets.",
      },
      foundation: {
        title: "Excavation de Fondation",
        description:
          "Excavation soigneuse pour fondations, murs de soutènement et structures en sous-sol.",
      },
      safety: {
        title: "Opération d'Équipement Sécuritaire",
        description:
          "Opérateurs certifiés et protocoles de sécurité adéquats sur chaque chantier, grand ou petit.",
      },
    },

    benefits: [
      "Équipement moderne pour des creusages efficaces et précis",
      "Opérateurs expérimentés et certifiés",
      "Nivellement adéquat pour prévenir les problèmes de drainage",
      "Nettoyage complet du site après chaque projet",
      "Projets résidentiels et commerciaux acceptés",
      "Conforme aux règlements locaux et aux normes de sécurité",
    ],

    processTitle: "Notre Processus d'Excavation",
    processDescription:
      "Excavation professionnelle de l'évaluation du site jusqu'au nettoyage final",
    process: {
      step1: {
        title: "Évaluation du Site",
        description:
          "Nous évaluons le site, localisons les services souterrains et planifions l'approche d'excavation la plus sécuritaire.",
      },
      step2: {
        title: "Plan d'Excavation",
        description:
          "Nous définissons la profondeur, l'ampleur et l'équipement nécessaires, puis confirmons le plan avec vous avant de commencer.",
      },
      step3: {
        title: "Travaux d'Excavation",
        description:
          "Notre équipe réalise l'excavation avec un équipement de précision, en respectant les spécifications de profondeur et de niveau.",
      },
      step4: {
        title: "Nettoyage du Site",
        description:
          "Nous enlevons tous les matériaux excavés, nivelons la zone restante et laissons le chantier en ordre.",
      },
    },

    ctaMiddle: {
      title: "Besoin d'un Travail d'Excavation Bien Fait?",
      subtitle:
        "Des petites fouilles résidentielles aux grands travaux de préparation commerciale, notre équipe a l'équipement et l'expérience pour livrer.",
      getQuote: "Obtenir un Devis Gratuit d'Excavation",
      callNow: "Appelez pour Discuter de Votre Projet",
    },

    cta: {
      title: "Démarrez Votre Projet d'Excavation Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services professionnels d'excavation et de préparation de terrain à travers l'Ouest de l'Île de Montréal.",
      getQuote: "Demander un Devis d'Excavation",
    },
  },

  // Snow Removal Service Page
  snowRemoval: {
    title: "Services de Déneigement",
    subtitle:
      "Déneigement rapide et fiable des entrées et pelletage des allées pour garder votre propriété sécuritaire et accessible tout l'hiver.",
    overviewTitle: "Déneigement Professionnel pour Entrées et Allées",
    overviewDescription:
      "Quand l'hiver montréalais frappe, nous gardons vos entrées dégagées et vos allées sécuritaires. Notre équipe de déneigement intervient rapidement après chaque tempête, offrant le déneigement des entrées, le pelletage des allées et des traitements glacioprotecteurs pour les propriétés résidentielles à travers l'Ouest de l'Île.",

    features: {
      plowing: {
        title: "Déneigement des Entrées",
        description:
          "Déneigement efficace des entrées après chaque chute de neige significative pour garder l'accès à votre véhicule dégagé.",
      },
      shoveling: {
        title: "Pelletage des Allées",
        description:
          "Pelletage à la main des allées piétonnes, marches et entrées pour un accès piéton sécuritaire.",
      },
      deicing: {
        title: "Glacioprotection et Salage",
        description:
          "Application de produits glacioprotecteurs pour prévenir l'accumulation de glace sur les entrées et allées.",
      },
      seasonal: {
        title: "Contrats Saisonniers",
        description:
          "Contrats saisonniers sans souci — nous surveillons la météo et intervenons automatiquement après chaque tempête.",
      },
      commercial: {
        title: "Propriétés Commerciales",
        description:
          "Services de déneigement pour stationnements commerciaux, allées et entrées.",
      },
      reliable: {
        title: "Intervention Fiable",
        description:
          "Intervention constante et rapide pour que votre propriété soit dégagée avant votre routine matinale.",
      },
    },

    benefits: [
      "Entrées et allées dégagées après chaque tempête",
      "Prévention des chutes avec un salage professionnel",
      "Contrats saisonniers pour un service automatique sans stress",
      "Équipe fiable qui se présente à temps, à chaque fois",
      "Propriétés résidentielles et commerciales desservies",
      "Protégez votre aménagement paysager d'un mauvais déneigement",
    ],

    processTitle: "Comment Fonctionne Notre Déneigement",
    processDescription:
      "Service simple et fiable de la première neige jusqu'au printemps",
    process: {
      step1: {
        title: "Inscrivez-vous au Service",
        description:
          "Contactez-nous avant le début de la saison pour assurer votre place sur notre route de déneigement.",
      },
      step2: {
        title: "Nous Surveillons la Météo",
        description:
          "Notre équipe suit les tempêtes et planifie nos équipes pour être prêts avant l'accumulation de neige.",
      },
      step3: {
        title: "Intervention après Tempête",
        description:
          "Après chaque tempête, nous déneigeons votre entrée, pelletons vos allées et appliquons le glacioprotecteur au besoin.",
      },
      step4: {
        title: "Tranquillité d'Esprit Tout l'Hiver",
        description:
          "Profitez d'une propriété dégagée et sécuritaire tout l'hiver sans pelleter vous-même.",
      },
    },

    ctaMiddle: {
      title: "Ne Restez pas Pris dans la Neige Cet Hiver",
      subtitle:
        "Assurez votre place sur notre route de déneigement avant que la saison soit complète.",
      getQuote: "Obtenir un Devis de Déneigement",
      callNow: "Appelez pour Réserver Votre Place",
    },

    cta: {
      title: "Restez en Sécurité Tout l'Hiver avec Bearz",
      subtitle:
        "Contactez-nous dès aujourd'hui pour des services professionnels de déneigement à travers l'Ouest de l'Île de Montréal.",
      getQuote: "Réserver le Déneigement Maintenant",
    },
  },

  // Sod Installation Service Page
  sodInstallation: {
    title: "Services Professionnels d'Installation de Gazon",
    subtitle:
      "Transformez votre pelouse instantanément avec nos services experts d'installation de gazon pour une herbe belle et saine prête à être appréciée immédiatement.",
    overviewTitle: "Installation de Gazon Expert et Transformation de Pelouse",
    overviewDescription:
      "Nos services professionnels d'installation de gazon fournissent une transformation instantanée de pelouse utilisant du gazon de qualité premium et des techniques d'installation expertes pour de belles pelouses saines que vous pouvez apprécier immédiatement.",

    features: {
      premium: {
        title: "Qualité de Gazon Premium",
        description:
          "Variétés de gazon de haute qualité, d'origine locale pour une croissance optimale.",
      },
      preparation: {
        title: "Préparation du Sol",
        description:
          "Préparation minutieuse du sol et nivellement pour un établissement optimal du gazon.",
      },
      installation: {
        title: "Installation Experte",
        description:
          "Techniques d'installation professionnelles pour des résultats beaux et sans couture.",
      },
      varieties: {
        title: "Variétés de Gazon",
        description:
          "Multiples variétés de gazon pour convenir à votre climat et besoins d'utilisation.",
      },
      care: {
        title: "Soins d'Installation",
        description:
          "Instructions de soins complètes et soutien pour l'établissement du nouveau gazon.",
      },
      warranty: {
        title: "Garantie d'Établissement",
        description:
          "Garantie sur l'établissement du gazon pour la tranquillité d'esprit.",
      },
    },

    benefits: [
      "Transformation instantanée de pelouse",
      "Qualité d'installation professionnelle",
      "Temps d'établissement de pelouse réduit",
      "Amélioration de la valeur de la propriété",
      "Sélection experte de gazon",
      "Soutien de soins complet",
    ],

    processTitle: "Notre Processus d'Installation de Gazon",
    processDescription:
      "Services professionnels d'installation de gazon pour une transformation instantanée de pelouse",
    process: {
      step1: {
        title: "Préparation du Site",
        description:
          "Nous préparons votre sol et nivelons la zone pour une installation optimale du gazon.",
      },
      step2: {
        title: "Sélection de Gazon",
        description:
          "Nous vous aidons à choisir la meilleure variété de gazon pour vos besoins spécifiques.",
      },
      step3: {
        title: "Installation Professionnelle",
        description:
          "Notre équipe installe votre gazon avec précision pour des résultats sans couture.",
      },
      step4: {
        title: "Instructions de Soins",
        description:
          "Nous fournissons des instructions de soins complètes pour un établissement optimal du gazon.",
      },
    },

    ctaMiddle: {
      title: "Prêt pour une Beauté de Pelouse Instantanée?",
      subtitle:
        "Nos experts en installation de gazon sont prêts à transformer votre pelouse immédiatement.",
      getQuote: "Obtenir un Devis Gratuit d'Installation de Gazon",
      callNow: "Appelez pour une Évaluation de Pelouse",
    },

    cta: {
      title: "Obtenez Votre Pelouse Parfaite Aujourd'hui",
      subtitle:
        "Contactez-nous pour des services professionnels d'installation de gazon qui vous donneront une belle pelouse instantanément.",
      getQuote: "Commencez Votre Transformation de Pelouse",
    },
  },

  // Services Modal
  servicesModal: {
    title: "Obtenez Votre Devis Gratuit Aujourd'hui!",
    subtitle:
      "Services d'aménagement paysager professionnels adaptés à vos besoins",
    benefit1: "Consultation gratuite et devis détaillé",
    benefit2: "Service professionnel et assuré",
    benefit3: "Garantie de satisfaction à 100%",
    getQuote: "Obtenir un Devis Gratuit",
    callNow: "Appelez Maintenant: 514-979-8020",
    disclaimer: "Aucune obligation. Consultation professionnelle incluse.",
  },

  // Floating Contact Button
  floatingContact: {
    contactUs: "Appelez",
    quickContact: "Contact Rapide",
    callNow: "Appelez",
    sendEmail: "Envoyer un Email",
  },
};
